import React from 'react';

import { addOrRemoveClass, classNames } from '@/shared/helpers';
import userIcon from '@/static/images/user.svg';
import { ILanguage } from '@/interfaces/languages';
import { IPageContext } from '@/interfaces/pageContext';
import { Languages } from '@/lib/LanguagesIncludingIcons';
import burgerMenuIcon from '@/static/images/burgermenu.svg';
import { addExternalLinksFlag } from '@/components/Headers/MainHeader/utils';
import { OrganizeProductsByCategory } from '@/lib/OrganizeProductsByCategory';

import './style.scss';
import PageList from './components/PageList';
import ProductList from './components/ProductList';
import LanguageSelector from './components/LanguageSelector';

interface Props {
  pageContext: IPageContext;
}

const Mobile = ({ pageContext }: Props) => {
  const { appData, lang, pathLang, currentPath, categoriesWithProducts } =
    pageContext;
  const { isMultiLanguage, locale, products, templateData } = appData;
  const { general, menu, pages } = templateData;
  const shouldApplyContrast = general.colors.contrast;

  const { productsWithoutCategory } = OrganizeProductsByCategory(products);
  const productsToListInMenu = menu.categoriesMenu
    ? productsWithoutCategory
    : products;
  const externalLinks = addExternalLinksFlag(menu.externalLinks);

  let extendedPages = menu.categoriesMenu
    ? [...categoriesWithProducts, ...pages]
    : pages;
  extendedPages = [...extendedPages, ...externalLinks];

  const currentLanguage =
    Languages.find((thisLang) => thisLang.lang === lang) || ({} as ILanguage);

  return (
    <>
      <div className="mobile-menu">
        <div
          className={classNames(
            'cart planne-widget planne-widget-cart-preview',
            shouldApplyContrast && 'cart-icon-with-contrast'
          )}
          data-widget-checkout-page="/pagamento/"
        />

        <button
          className={classNames(
            'burger-menu-button',
            shouldApplyContrast && 'image-with-contrast'
          )}
          onClick={() => addOrRemoveClass('active', '#responsive-navbar')}
        >
          <img src={burgerMenuIcon} alt={locale.header.open_responsive_menu} />
        </button>
      </div>

      <section id="responsive-navbar" className="responsive-navbar">
        <div className="anim-drop-down default-screen-size responsive-navbar-content">
          <nav>
            <a href={`/${pathLang}minha-conta`}>
              <div
                className={classNames(
                  'anim-drop-down-item signin-signup',
                  shouldApplyContrast && 'image-with-contrast'
                )}
              >
                <img src={userIcon} alt={locale.header.user_icon} />
                <p>{locale.header.signin_signup}</p>
              </div>
            </a>

            {isMultiLanguage ? (
              <LanguageSelector
                currentLanguage={currentLanguage}
                currentPath={currentPath}
                languages={Languages}
                shouldApplyContrast={shouldApplyContrast}
                locale={locale}
              />
            ) : null}

            <div
              className={classNames(
                'divisor-border',
                shouldApplyContrast
                  ? 'border-with-contrast'
                  : 'border-without-contrast '
              )}
            />

            <ul className="navbar-list">
              {productsToListInMenu.length > 0 ? (
                <li className="anim-drop-down-item nav-item">
                  <ProductList
                    products={productsToListInMenu}
                    pathLang={pathLang}
                    lang={lang}
                    locale={locale}
                    shouldApplyContrast={shouldApplyContrast}
                  />
                </li>
              ) : null}

              <PageList pages={extendedPages} pathLang={pathLang} />
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
};

export default Mobile;
